var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueFormNotification',{attrs:{"type":"error","inverse":true}},[_c('p',[_vm._v("Sajnáljuk, de technikai probléma miatt sajnos nem sikerült a kalkuláció!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }